var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({attrs:{"icon":""},on:{"mousedown":function($event){$event.stopPropagation();},"touchstart":function($event){$event.stopPropagation();},"click":function($event){$event.stopPropagation();return _vm.$emit('action')}}},'v-btn',_vm.$attrs,false),[_c('v-icon',[_vm._v("$"+_vm._s(_vm.iconName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }